import { QueryClientProvider } from '@tanstack/react-query';
import React, { type PropsWithChildren } from 'react';
import { defaultQueryClient } from './DefaultQueryClient';

const ReactQueryDevtools =
  import.meta.env.MODE === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/react-query-devtools').then((res) => ({
          default: res.ReactQueryDevtools,
        }))
      );

type ReactQueryCustomProviderProps = PropsWithChildren<{
  queryClient?: typeof defaultQueryClient;
}>;

export function ReactQueryCustomProvider({ children, queryClient }: ReactQueryCustomProviderProps) {
  return (
    <QueryClientProvider client={queryClient ?? defaultQueryClient}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}
